import React from "react";
import "style/Footer.scss";

import { Link } from "react-router-dom";
import en from "../config/i18n/english/english";
import de from "../config/i18n/german/german";

import { default as SvgFooterSocialMediaLinkedin2 } from "assets/SvgFooterSocialMediaLinkedin.svg";
import { default as SvgFooterSocialMediaXing2 } from "assets/SvgFooterSocialMediaXing.svg";

import { default as SvgFooterPhone } from "assets/SvgFooterPhone.svg";
import { default as SvgFooterMail } from "assets/SvgFooterMail.svg";

//import { default as SvgFooterCompany1 } from "assets/SvgFooterCompany1.svg";
import { default as SvgFooterCompany2 } from "assets/SvgFooterCompany2.svg";
import { default as SvgFooterCompany3 } from "assets/SvgFooterCompany3.svg";

import { default as SvgHeaderTitle } from "assets/SvgHeaderTitle.svg";
import { default as SvgFooterCompany4 } from "assets/SvgFooterCompany4.svg";

interface Props {
  dropdownProp?: boolean;
}

interface State {
  language: any;
}

class Footer extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      language: en,
    };
  }

  componentDidMount() {
    if (sessionStorage.getItem("lang") === null) {
      const browserLanguage = navigator.language.split("-")[0];
      this.setState({
        language: browserLanguage === "de" ? de : en,
      });
    } else {
      const sessionLang = sessionStorage.getItem("lang");
      this.setState({
        language: sessionLang === "de" ? de : en,
      });
    }
  }

  render() {
    const { language } = this.state;

    return (
      <>
        <div className="footer">
          <div className="footer-content">
            <div className="footer-head">
              <div className="footer-head-l">
                <img
                  src={SvgHeaderTitle}
                  className="footer-title"
                  alt="Title"
                />
                <div className="footer-fullName">MARKSIM Services GmbH</div>
              </div>
              <div className="footer-head-r">
                <a
                  href={process.env.React_App_LINKEDIN}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-media-linkedin"
                >
                  <img
                    src={SvgFooterSocialMediaLinkedin2}
                    alt="Machine Learning"
                  />
                </a>
                <a
                  href={process.env.React_App_XING}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-media-xing"
                >
                  <img src={SvgFooterSocialMediaXing2} alt="Machine Learning" />
                </a>
              </div>
            </div>

            <div className="footer-contact-main">
              <div className="footer-contact">
                <p className="footer-contact-description">
                  <span>{language.footer.contactHeader[0]}</span>
                  <span>{language.footer.contactHeader[1]}</span>
                </p>
                <span className="footer-contact-contact">
                  {language.footer.contactBody}
                </span>
                <span className="footer-contact-phone">
                  <img src={SvgFooterPhone} alt="svg Footer Phone" />
                  <span>
                    <a href="tel:004312051085250">+43 1 205 108 525-0</a>
                  </span>
                </span>
                <span className="footer-contact-email">
                  <img src={SvgFooterMail} alt="svg Footer Mail" />
                  <span>
                    <a href="mailto:sales-team@marksim.org</Link>">
                      sales-team@marksim.org
                    </a>
                  </span>
                </span>
              </div>
            </div>

            <div className="footer-companies">
             {/* <div>
                <img
                  src={SvgFooterCompany1}
                  className="svg-companies"
                  alt="svg Footer Company1"
                />

                <p>{language.footer.FOOTER_COMPANIES[0]}</p>
              </div> */}
              <div> 
                <img
                  src={SvgFooterCompany2}
                  className="svg-companies"
                  alt="svg Footer Company2"
                />
                <p>{language.footer.FOOTER_COMPANIES[1]}</p>
              </div>
              <div>
                <img
                  src={SvgFooterCompany3}
                  className="svg-companies"
                  alt="svg Footer Company3"
                />

                <p>{language.footer.FOOTER_COMPANIES[2]}</p>
              </div>
              <div className="footerCompanies4">
                <img
                  src={SvgFooterCompany4}
                  className="svg-companies"
                  alt="Go International"
                />
                <p>{language.footer.FOOTER_COMPANIES[3]}</p>
              </div>
            </div>

            <div className="footer-bottom">
              <span>&copy; MARKSIM 2022</span>
              {" | "}
              <Link to="/contact">{language.footer.contact}</Link>
              {" | "}
              <Link to="/imprint">
                {language.footer.imprint} & {language.footer.GDPR}
              </Link>
              {" | "}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Footer;
